import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  Home, 
  Plane, 
  Users,
  User
} from 'lucide-react';

const menuItems = [
  { path: '/dashboard', icon: Home, label: 'Dashboard', color: 'from-blue-500 to-blue-600' },
  { path: '/trips', icon: Plane, label: 'Minhas Viagens', color: 'from-indigo-500 to-indigo-600' },
  { path: '/companions', icon: Users, label: 'Acompanhantes', color: 'from-purple-500 to-purple-600' },
  { path: '/profile', icon: User, label: 'Meu Perfil', color: 'from-green-500 to-green-600' },
];

// Mobile Navigation Component
export const MobileNavigation: React.FC<{ onClose?: () => void }> = ({ onClose }) => {
  const location = useLocation();

  const handleLinkClick = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    <nav className="space-y-2">
      {menuItems.map((item) => {
        const Icon = item.icon;
        const isActive = location.pathname === item.path;
        
        return (
          <Link
            key={item.path}
            to={item.path}
            onClick={handleLinkClick}
            className={`group flex items-center space-x-3 px-4 py-3 rounded-xl text-sm font-medium transition-all duration-200 ${
              isActive
                ? 'bg-gradient-to-r from-blue-50 to-indigo-50 text-blue-700 border border-blue-200 shadow-sm'
                : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
            }`}
          >
            <div className={`p-2 rounded-lg transition-all duration-200 ${
              isActive 
                ? `bg-gradient-to-br ${item.color} shadow-lg`
                : 'bg-gray-100 group-hover:bg-gray-200'
            }`}>
              <Icon className={`h-4 w-4 ${
                isActive ? 'text-white' : 'text-gray-600 group-hover:text-gray-700'
              }`} />
            </div>
            <span className={isActive ? 'font-semibold' : ''}>{item.label}</span>
            {isActive && (
              <div className="ml-auto w-2 h-2 bg-blue-500 rounded-full"></div>
            )}
          </Link>
        );
      })}
    </nav>
  );
};

const Sidebar: React.FC = () => {
  const location = useLocation();

  return (
    <>
      {/* Desktop Sidebar */}
      <aside className="hidden lg:block fixed left-0 top-16 w-64 h-[calc(100vh-4rem)] bg-white/95 backdrop-blur-sm shadow-xl border-r border-gray-200/50 overflow-y-auto">
        <div className="p-4">
          {/* Navigation */}
          <nav className="space-y-2">
            {menuItems.map((item) => {
              const Icon = item.icon;
              const isActive = location.pathname === item.path;
              
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`group flex items-center space-x-3 px-4 py-3 rounded-xl text-sm font-medium transition-all duration-200 ${
                    isActive
                      ? 'bg-gradient-to-r from-blue-50 to-indigo-50 text-blue-700 border border-blue-200 shadow-sm'
                      : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                  }`}
                >
                  <div className={`p-2 rounded-lg transition-all duration-200 ${
                    isActive 
                      ? `bg-gradient-to-br ${item.color} shadow-lg`
                      : 'bg-gray-100 group-hover:bg-gray-200'
                  }`}>
                    <Icon className={`h-4 w-4 ${
                      isActive ? 'text-white' : 'text-gray-600 group-hover:text-gray-700'
                    }`} />
                  </div>
                  <span className={isActive ? 'font-semibold' : ''}>{item.label}</span>
                  {isActive && (
                    <div className="ml-auto w-2 h-2 bg-blue-500 rounded-full"></div>
                  )}
                </Link>
              );
            })}
          </nav>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
